// Map of JSON escape sequences to their unescaped values
const ESCAPE_MAP: Record<string, string> = {
	'"': '"',
	'\\': '\\',
	'/': '/',
	b: '\b',
	f: '\f',
	n: '\n',
	r: '\r',
	t: '\t',
};

/**
 * Unescapes JSON escape sequences in a string using a character-by-character state machine,
 * similar to how JSON.parse works.
 *
 * Handles all 9 valid JSON escape sequences per the JSON specification (https://www.json.org/):
 * - \" (quotation mark / double quote)
 * - \\ (reverse solidus / backslash)
 * - \/ (solidus / forward slash)
 * - \b (backspace)
 * - \f (form feed)
 * - \n (line feed / newline)
 * - \r (carriage return)
 * - \t (character tabulation / tab)
 * - \uXXXX (Unicode escape with 4 hex digits)
 *
 * Invalid escape sequences (e.g., \uXYZW) are preserved as-is.
 *
 * @param str The string containing JSON escape sequences
 * @returns The unescaped string
 */
export function unescapeJsonString(str: string): string {
	// eslint-disable-next-line require-unicode-regexp
	return str.replace(/\\(?:u[0-9a-fA-F]{4}|.)/g, (match) => {
		// Valid unicode escape is always 6 characters: \uXXXX
		if (match[1] === 'u' && match.length === 6) {
			return String.fromCharCode(parseInt(match.slice(2), 16));
		}
		// Single-character escape: 2 characters (\X)
		return ESCAPE_MAP[match[1]] ?? match;
	});
}
